var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-cont-banner", attrs: { id: "rightContBan" } },
    [
      _c(
        "div",
        { staticClass: "top-categories" },
        _vm._l(_vm.tabTypes, function(tabType) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              key: tabType.id,
              staticClass: "top-option",
              on: {
                click: function($event) {
                  return _vm.switchTabCategories(tabType.id)
                }
              }
            },
            [
              _c(
                "span",
                {
                  style:
                    _vm.tabCategories == tabType.id ? "color: #FFFFFF;" : ""
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.rightTopBanner.nav" + tabType.name))
                  )
                ]
              ),
              _vm._v(" "),
              tabType.isNew
                ? _c("div", { staticClass: "top-option-new" }, [
                    _vm._v(_vm._s(_vm.$t("language.leftBanner.new")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tabCategories == tabType.id
                ? _c("div", { staticClass: "top-option-select" })
                : _c("div", { staticClass: "top-option-hover" })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.resetEmail,
              expression: "$store.state.resetEmail"
            }
          ],
          staticClass: "tourest-text",
          style: { width: _vm.getTxtWidth() }
        },
        [
          _c("div", {
            staticClass: "icon-mail-hint",
            staticStyle: { margin: "4px 10px" }
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("language.rightTopBanner.bindMailTips")) + " ")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "bindEmailBtn",
              style: { right: _vm.getBtnWidth() },
              on: {
                click: function($event) {
                  return _vm.bindEmailOpen()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.rightTopBanner.bind")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tips-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.close")))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.iePromptShow,
              expression: "iePromptShow"
            }
          ],
          staticClass: "browser-prompt",
          style: { width: _vm.getPromptWidth() }
        },
        [
          _c(
            "span",
            [
              _c("font", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("language.rightTopBanner.browserPrompt")
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon-util top-close top-close-button",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.iePromptShow = false
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "personal-center" }, [
        _c(
          "div",
          {
            staticClass: "center-left",
            staticStyle: { width: "35Px", position: "relative" }
          },
          [
            _vm.user.payType != "Lifetime" && !_vm.isDemoUser()
              ? _c("div", {
                  staticClass: "personal-left license-icon",
                  attrs: { id: "licenseIcon" },
                  on: {
                    click: function($event) {
                      return _vm.openLicenseCodePopup()
                    }
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "center-left" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "clickoutside",
                  rawName: "v-clickoutside",
                  value: _vm.personalMenuClose,
                  expression: "personalMenuClose"
                }
              ],
              staticClass: "icon-util personal personal-left",
              class: _vm.personalMenuShow ? "personal-hover" : "",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.personalMenuOpen()
                }
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.personalMenuShow,
                      expression: "personalMenuShow"
                    }
                  ],
                  ref: "personalMenu",
                  staticClass: "personal-menu",
                  attrs: { "data-lite": _vm.$store.state.isLiteMode }
                },
                [
                  _c("i", { staticClass: "sharp-angle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "personal-account" }, [
                    _c(
                      "div",
                      {
                        staticClass: "personal-account-item",
                        attrs: { title: _vm.email }
                      },
                      [_vm._v(_vm._s(_vm.email))]
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isDemoUser()
                    ? _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            mouseenter: function($event) {
                              return _vm.changePass()
                            },
                            mouseleave: function($event) {
                              _vm.selectMenuIndex = -1
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util properties personal-icon-position",
                            staticStyle: {
                              top: "10Px !important",
                              margin: "0 3Px 0Px 3Px !important"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.rightTopBanner.settings"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "icon-util pull-triangle personal-moremenu-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.selectMenuIndex == 0,
                                  expression: "selectMenuIndex==0"
                                }
                              ],
                              ref: "setMenuOne",
                              staticClass: "personal-setting-menu"
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.judgeTourist(),
                                      expression: "!judgeTourist()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeNameOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "changeName",
                                      staticClass: "setting-position"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.rightTopBanner.changeName"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.judgeTourist() &&
                                        !_vm.judgeThird(),
                                      expression:
                                        "!judgeTourist()&&!judgeThird()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changePassOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "changePassWord",
                                      staticClass: "setting-position"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.rightTopBanner.changePassword"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.judgeTourist(),
                                      expression: "judgeTourist()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.bindEmailOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "setting-position" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.rightTopBanner.bindEmail"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.twoStepverification &&
                                        !_vm.judgeThird(),
                                      expression:
                                        "twoStepverification&&!judgeThird()"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.openVertificationDialog($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      ref: "twoStepverifiTxt",
                                      staticClass: "setting-position"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.twoStepverification.twoStep"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$store.state.isLiteMode,
                                      expression: "$store.state.isLiteMode"
                                    }
                                  ],
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.openLiteAppManager()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "setting-position" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.liteApp.menu"))
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "personal-info",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteAccountOpen()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "setting-position" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.rightTopBanner.deleteAccount"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "personal-info",
                      on: {
                        mouseenter: function($event) {
                          _vm.selectMenuIndex = 1
                        },
                        mouseleave: function($event) {
                          _vm.selectMenuIndex = -1
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "icon-util multi-language personal-icon-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "personal-item" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.rightTopBanner.language"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "icon-util pull-triangle personal-moremenu-position"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectMenuIndex == 1,
                              expression: "selectMenuIndex==1"
                            }
                          ],
                          staticClass: "personal-setting-menu"
                        },
                        _vm._l(_vm.languageArr, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "personal-info",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.checkLanguage(index)
                                }
                              }
                            },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.checkLanguageIndex == index,
                                    expression: "checkLanguageIndex==index"
                                  }
                                ],
                                staticClass:
                                  "icon-util language-check language-check-position"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "language-position" }, [
                                _vm._v(_vm._s(item))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "personal-info",
                      on: {
                        mouseenter: function($event) {
                          return _vm.menuHelpShow()
                        },
                        mouseleave: function($event) {
                          _vm.selectMenuIndex = -1
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util help personal-icon-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "personal-item " }, [
                        _vm._v(_vm._s(_vm.$t("language.rightTopBanner.help")))
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "icon-util pull-triangle personal-moremenu-position"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectMenuIndex == 2,
                              expression: "selectMenuIndex==2"
                            }
                          ],
                          ref: "setMenuTwo",
                          staticClass: "personal-setting-menu"
                        },
                        _vm._l(_vm.helpArr, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "personal-info",
                              on: {
                                click: function($event) {
                                  return _vm.openHelpLink(index)
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  ref: "detail",
                                  refInFor: true,
                                  staticClass: "setting-position"
                                },
                                [_vm._v(_vm._s(item))]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isDemoUser()
                    ? _c(
                        "div",
                        {
                          staticClass: "personal-info",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.inviteFriends()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon-util if_Invite_friends_top personal-icon-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "personal-item" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.leftBanner.inviteFriends")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.$store.state.isLiteMode && !_vm.isDemoUser(),
                          expression:
                            "!$store.state.isLiteMode && !isDemoUser()"
                        }
                      ],
                      staticClass: "personal-info",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.subAccountShow()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "icon-util sub-account-new personal-icon-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "personal-item " }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.rightTopBanner.subAccount"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "personal-info",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.getNotifications()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "icon-util notify-icon personal-icon-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "personal-item" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.rightTopBanner.notification"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "personal-info",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.logout()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util logout personal-icon-position",
                        staticStyle: { margin: "0 1px 0 5px!important" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "personal-item" }, [
                        _vm._v(_vm._s(_vm.$t("language.rightTopBanner.logout")))
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "center-right" }, [
          _c("div", { staticClass: "center-right-position" }, [
            _vm.saleShow && _vm.user.payType != "Lifetime" && !_vm.isDemoUser()
              ? _c("div", {
                  staticClass: "saleImg",
                  attrs: { id: "saleImg" },
                  on: {
                    click: function($event) {
                      return _vm.salePopupShow(true)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.user.payType == "Lifetime"
              ? _c(
                  "button",
                  {
                    staticClass: "upgrade-button",
                    on: {
                      click: function($event) {
                        return _vm.switchToPay()
                      }
                    }
                  },
                  [
                    _vm.payBtn.img
                      ? _c("div", {
                          staticClass: "right-top-icon icon",
                          class: _vm.payBtn.img
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "payTxt" }, [
                      _vm._v(_vm._s(_vm.payBtn.txt))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.user.payType != "Lifetime" && !_vm.isDemoUser()
              ? _c(
                  "button",
                  {
                    staticClass: "upgrade-button",
                    class: _vm.timerExpired ? "active-upgrade-button" : "",
                    on: {
                      click: function($event) {
                        return _vm.switchToPay()
                      }
                    }
                  },
                  [
                    _vm.payBtn.img
                      ? _c("div", {
                          staticClass: "right-top-icon icon",
                          class: _vm.payBtn.img
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "payTxt" }, [
                      _vm._v(_vm._s(_vm.payBtn.txt))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "right-content" }, [
              _c("div", { staticClass: "progress-bar" }, [
                _c("div", {
                  class: _vm.btnColor == "grey" ? "" : "inner-progress-bar",
                  style: {
                    width: (_vm.usedTraffic / _vm.totalTraffic) * 100 + "%"
                  }
                })
              ]),
              _vm._v(" "),
              _vm.totalTraffic != -1
                ? _c("div", { staticClass: "drive-space" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("language.rightTopBanner.traffic")) +
                        ":" +
                        _vm._s(_vm._f("formatByteForBanner")(_vm.usedTraffic)) +
                        "/" +
                        _vm._s(
                          _vm._f("formatByteForBanner")(_vm.totalTraffic)
                        ) +
                        "\n                    "
                    )
                  ])
                : _c("div", { staticClass: "drive-space" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("language.rightTopBanner.traffic")) +
                        ":" +
                        _vm._s(_vm._f("formatByteForBanner")(_vm.usedTraffic)) +
                        "/" +
                        _vm._s(_vm.$t("language.rightTopBanner.unlimited")) +
                        "\n                    "
                    )
                  ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.funnelShow
          ? _c("div", { staticClass: "top-funnel" }, [
              _c(
                "div",
                {
                  staticClass: "purple-funnel",
                  attrs: { id: "purpleFun" },
                  on: {
                    click: function($event) {
                      return _vm.openFunnelPreSet()
                    }
                  }
                },
                [
                  _vm.orangeShow
                    ? _c("div", {
                        staticClass: "orange-notice orange-notice-position"
                      })
                    : _vm._e()
                ]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("bindEmailDialog", { ref: "bindEmailDialog" }),
      _vm._v(" "),
      _c("notificationsDialog", { ref: "notificationsDialog" }),
      _vm._v(" "),
      _c("bindEmailJumpDialog", { ref: "bindEmailJumpDialog" }),
      _vm._v(" "),
      _c("updateVerificationDialog", { ref: "updateVerificationDialog" }),
      _vm._v(" "),
      _c("stepVerificationDialog", { ref: "stepVerificationDialog" }),
      _vm._v(" "),
      _c("verifiSettingDialog", { ref: "verifiSettingDialog" }),
      _vm._v(" "),
      _c("removeAllDevicesDialog", { ref: "removeAllDevicesDialog" }),
      _vm._v(" "),
      _c("licenseCodeDialog", { ref: "licenseCodeDialog" }),
      _vm._v(" "),
      _c("licenseShowDialog", {
        ref: "licenseShowDialog",
        attrs: { subscrId: _vm.user.subscrId }
      }),
      _vm._v(" "),
      _c("giveawayActiveSucDialog", { ref: "giveawayActiveSucDialog" }),
      _vm._v(" "),
      _c("giveawayActiveSucDialog", {
        ref: "giveawayActiveYearSucDialog",
        attrs: { "is-one-year-giveaway": true }
      }),
      _vm._v(" "),
      _c("liteAppManagePopup", { ref: "liteAppManagePopup" }),
      _vm._v(" "),
      _vm.$store.state.showWebsiteGuideMask
        ? _c("div", { staticClass: "guide_mask" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1393ea9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1393ea9d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/right_top_banner.vue
// module id = null
// module chunks = 